<template>
  <v-app>
    <div id="fb-root"></div>
    <NavBar />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import NavBar from './components/nav/NavBar'

export default {
  name: 'App',
  components: {
    NavBar
  },
  computed: {
    isLoggedIn() { return this.$store.getters.isLoggedIn },
  },
};
</script>


<style>
@import "./styles/global.scss";
 .v-application {
   background-color: #F7F7F9 !important;
 }
</style>
